export default __webpack_public_path__ + "static/media/landing_page_hex_5.3a6ba794.png";